<script setup lang="ts">
import { formatAdminDateTime, getOrderStatusLabel } from './admin-model';

defineProps<{
  order: Record<string, any> | null;
  vouchers: Record<string, any>[];
  loading?: boolean;
  error?: string;
  canRefund?: boolean;
}>();

const emit = defineEmits<{
  close: [];
  refund: [];
}>();

function voucherStateLabel(state: string | undefined): string {
  if (state === 'REDEEMED') return '已核销';
  if (state === 'REFUNDED') return '已退款';
  return '待核销';
}
</script>

<template>
  <div v-if="order || loading" class="drawer-backdrop" @click.self="emit('close')">
    <aside class="detail-drawer" role="dialog" aria-label="订单详情">
      <div class="drawer-heading">
        <div><span class="eyebrow">ORDER DETAIL</span><h2>订单详情</h2></div>
        <button class="drawer-close" type="button" aria-label="关闭" @click="emit('close')">×</button>
      </div>
      <div v-if="loading" class="empty-state">正在读取真实订单详情…</div>
      <div v-else-if="error" class="empty-state order-error-state"><strong>订单详情暂时无法加载</strong><span>{{ error }}</span></div>
      <template v-else-if="order">
        <div class="detail-status"><span class="status-pill info">{{ getOrderStatusLabel(order.rawStatus) }}</span><span class="order-code">{{ order.id }}</span></div>
        <dl class="detail-list">
          <div><dt>套餐</dt><dd>{{ order.packageSnapshot?.name ?? order.item ?? '团购套餐' }}</dd></div>
          <div><dt>数量</dt><dd>{{ order.quantity ?? 0 }} 份</dd></div>
          <div><dt>订单金额</dt><dd>¥{{ ((order.totalAmountFen ?? 0) / 100).toFixed(2) }}</dd></div>
          <div><dt>下单时间</dt><dd>{{ formatAdminDateTime(order.createdAt) }}</dd></div>
          <div><dt>支付时间</dt><dd>{{ order.paidAt ? formatAdminDateTime(order.paidAt) : '未支付' }}</dd></div>
        </dl>
        <div class="drawer-section"><div class="drawer-section-heading"><h3>团购券明细</h3><span>{{ vouchers.length }} 张</span></div><div class="voucher-detail-list"><div v-for="voucher in vouchers" :key="voucher.id" class="voucher-detail-row"><span class="order-code">{{ voucher.shortCode ?? voucher.id }}</span><span>{{ voucherStateLabel(voucher.state) }}</span></div><div v-if="vouchers.length === 0" class="empty-state compact">暂无券明细</div></div></div>
        <div class="drawer-actions"><button v-if="canRefund" type="button" class="danger-button" @click="emit('refund')">退款未核销券</button><button type="button" class="outline-button" @click="emit('close')">关闭</button></div>
      </template>
    </aside>
  </div>
</template>
